import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a0e1a]/95 backdrop-blur-sm shadow-lg py-2 border-b border-gray-800' : 'bg-transparent py-2'}`} data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="flex items-center justify-between" data-id="element-92">
          <div className="flex-shrink-0 cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-93">
            <span className="text-[#E8C547] font-bold text-lg sm:text-2xl tracking-tight drop-shadow-[0_0_8px_rgba(212,168,67,0.4)]" data-id="element-94">
              KitLenguayLiteratura
            </span>
          </div>

          <nav className="hidden md:flex items-center space-x-8" data-id="element-95">
            <button onClick={() => scrollToSection('que-incluye')} className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-96">
              Qué incluye
            </button>
            <button onClick={() => scrollToSection('beneficios')} className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-97">
              Beneficios
            </button>
            <button onClick={() => scrollToSection('bonus')} className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-98">
              Bonus
            </button>
            <button onClick={() => scrollToSection('testimonios')} className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-99">
              Testimonios
            </button>
          </nav>

          <div className="hidden md:block" data-id="element-100">
            <button onClick={() => scrollToSection('oferta')} className="bg-[#D4A843] hover:bg-[#B8922E] text-white font-bold py-2 px-6 rounded-full transition-all transform hover:scale-105 shadow-[0_0_15px_rgba(212,168,67,0.4)] border-2 border-[#9A7B24] animate-subtle-bounce" data-id="element-101">
              COMPRAR
            </button>
          </div>

          <div className="md:hidden flex items-center gap-2" data-id="element-102">
            <button onClick={() => scrollToSection('oferta')} className="bg-[#D4A843] text-white text-sm font-bold py-1.5 px-3 rounded-full shadow-[0_0_10px_rgba(212,168,67,0.4)] animate-subtle-bounce" data-id="element-103">
              COMPRAR
            </button>
            <button onClick={() => setIsOpen(!isOpen)} className="text-white p-1.5" aria-label="Menu" data-id="element-104">
              {isOpen ? <XIcon size={20} data-id="element-105" /> : <MenuIcon size={20} data-id="element-106" />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && <div className="md:hidden bg-[#0a0e1a] border-t border-gray-800 absolute w-full" data-id="element-107">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-108">
            <button onClick={() => scrollToSection('que-incluye')} className="block w-full text-left px-3 py-3 text-lg font-medium text-white hover:bg-gray-800 rounded-md" data-id="element-109">
              Qué incluye
            </button>
            <button onClick={() => scrollToSection('beneficios')} className="block w-full text-left px-3 py-3 text-lg font-medium text-white hover:bg-gray-800 rounded-md" data-id="element-110">
              Beneficios
            </button>
            <button onClick={() => scrollToSection('bonus')} className="block w-full text-left px-3 py-3 text-lg font-medium text-white hover:bg-gray-800 rounded-md" data-id="element-111">
              Bonus
            </button>
            <button onClick={() => scrollToSection('testimonios')} className="block w-full text-left px-3 py-3 text-lg font-medium text-white hover:bg-gray-800 rounded-md" data-id="element-112">
              Testimonios
            </button>
          </div>
        </div>}
    </header>;
}